import { Currency } from '@/core/currency/interfaces';

const GMD: Currency = {
    name: 'Gambian Dalasi',
    demonym: 'Gambian',
    majorSingle: 'Dalasi',
    majorPlural: 'Dalasis',
    codeNumeric: '270',
    symbol: 'D',
    symbolNative: 'D',
    minorSingle: 'Butut',
    minorPlural: 'Bututs',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'GMD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default GMD;
